import { ACTION_CENTER_POPOVER_SEEN_KEY } from "../../constants/recommendations";

// Dismissals are tracked per property (a JSON array of property ids) so
// switching hotels re-arms the popover for properties the user hasn't
// dismissed or acted on yet this session.
export const getDismissedPopoverPropertyIds = () => {
  try {
    const parsed = JSON.parse(
      sessionStorage.getItem(ACTION_CENTER_POPOVER_SEEN_KEY)
    );
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const markPopoverDismissedForProperty = (propertyId) => {
  if (propertyId == null) return;
  const ids = getDismissedPopoverPropertyIds();
  if (!ids.includes(propertyId)) {
    sessionStorage.setItem(
      ACTION_CENTER_POPOVER_SEEN_KEY,
      JSON.stringify([...ids, propertyId])
    );
  }
};
